// src/app/interceptors/file-transfer.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { EXPECTS_CSV, EXPECTS_XLSX } from '../core/http/http-context.tokens';

/**
 * Normalizes download semantics for known endpoints.
 * Priority:
 *  1) HttpContext flags (EXPECTS_CSV / EXPECTS_XLSX)
 *  2) Fallback URL pattern matching (no '/seo/' dependency)
 */
export const FileTransferInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url;
  const isJson = req.responseType === 'json';

  // --- 1) Context-first handling ---
  if (isJson && req.context.get(EXPECTS_CSV)) {
    const headers = req.headers.set('Accept', 'text/csv');
    return next(req.clone({ headers, responseType: 'blob' }));
  }

  if (isJson && req.context.get(EXPECTS_XLSX)) {
    // We don't force Content-Type; server decides. Response must be blob.
    return next(req.clone({ responseType: 'blob' }));
  }

  // --- 2) Fallback URL patterns (host-agnostic) ---

  // Statistics signals CSV
  if (isJson && url.includes('signals/csv')) {
    const headers = req.headers.set('Accept', 'text/csv');
    return next(req.clone({ headers, responseType: 'blob' }));
  }

  // Statistics XLSX exports (common patterns)
  const looksLikeXlsx =
    url.includes('/statistics/') &&
    (url.includes('export') || url.includes('xlsx') || url.endsWith('.xlsx'));

  if (isJson && looksLikeXlsx) {
    return next(req.clone({ responseType: 'blob' }));
  }

  return next(req);
};
